/**
 * @param t: string
 * @param x
 * @param u 设置cookie
 * @param extendCookie
 * @returns
 */
export function setCookie(t: string, x: string, u: Record<string, any>, extendCookie?: string) {
  const cookie = typeof document === 'undefined' ? (extendCookie || '') : document.cookie
  if (typeof x != 'undefined') {
    u = u || {}
    if (x === null) {
      x = ''
      u.expires = -1
    }
    let r = ''
    if (u.expires && (typeof u.expires == 'number' || u.expires.toUTCString)) {
      let p
      if (typeof u.expires == 'number') {
        p = new Date()
        p.setTime(p.getTime() + (u.expires * 24 * 60 * 60 * 1000))
      }
      else {
        p = u.expires
      }
      r = `; expires=${p.toUTCString()}`
    }
    const v = u.path ? `; path=${u.path}` : ''
    const q = u.domain ? `; domain=${u.domain}` : ''
    const w = u.secure ? '; secure' : ''
    x = u.unEncoded ? x : encodeURIComponent(x)
    if (typeof document !== 'undefined') {
      document.cookie = [t, '=', x, r, v, q, w].join('')
    }
  }
  else {
    let o = null
    if (cookie && cookie !== '') {
      const n = cookie.split('; ')
      for (let s = 0; s < n.length; s++) {
        const i = n[s]
        if (i.substring(0, t.length + 1) === (`${t}=`)) {
          o = decodeURIComponent(i.substring(t.length + 1))
          break
        }
      }
    }
    return o
  }
}
